var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amount-card--container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('h4',{staticClass:"amount-card--title"},[_vm._v(_vm._s(_vm.amount))]),_c('p',{staticClass:"amount-card--name"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"amount-card--description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }